import { FaLinkedinIn, FaTwitter, FaInstagram } from 'react-icons/fa';
import { HiMail } from 'react-icons/hi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { Icon: FaLinkedinIn, href: '#', label: 'LinkedIn' },
    { Icon: FaTwitter, href: '#', label: 'Twitter' },
    { Icon: FaInstagram, href: '#', label: 'Instagram' },
    { Icon: HiMail, href: 'mailto:hello@susana.com', label: 'Email' },
  ];

  const footerLinks = [
    { name: 'Privacy Policy', href: '#' },
    { name: 'Terms of Service', href: '#' },
    { name: 'Imprint', href: '#' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer
      data-testid="footer"
      className="section-dark py-16 md:py-24"
    >
      <div className="container-main">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          {/* Left - Big CTA */}
          <div>
            <h3
              className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#FDFBF7] mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              data-testid="footer-headline"
            >
              Let's Talk
            </h3>
            <p className="body-large text-[#FDFBF7]/70 mb-8">
              Ready to transform your leadership approach?
            </p>
            <a
              href="mailto:hello@susana.com"
              className="inline-flex items-center gap-2 text-[#FDFBF7] text-lg hover:text-[#9CAF88] transition-colors link-hover"
              data-testid="footer-email"
            >
              hello@susana.com
            </a>
          </div>

          {/* Right - Navigation & Social */}
          <div className="md:text-right">
            {/* Logo */}
            <button
              onClick={scrollToTop}
              className="text-2xl font-light tracking-[0.15em] text-[#FDFBF7] mb-8 inline-block hover:text-[#9CAF88] transition-colors"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              data-testid="footer-logo"
            >
              SUSANA
            </button>

            {/* Social Links */}
            <div className="flex gap-4 md:justify-end mb-8">
              {socialLinks.map(({ Icon, href, label }, index) => (
                <a
                  key={index}
                  href={href}
                  aria-label={label}
                  className="w-10 h-10 rounded-full border border-[#FDFBF7]/20 flex items-center justify-center text-[#FDFBF7]/70 hover:bg-[#FDFBF7]/10 hover:text-[#FDFBF7] transition-all"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>

            {/* Footer Links */}
            <div className="flex flex-wrap gap-6 md:justify-end">
              {footerLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-sm text-[#FDFBF7]/50 hover:text-[#FDFBF7] transition-colors"
                  data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#FDFBF7]/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#FDFBF7]/50" data-testid="footer-copyright">
              © {currentYear} Susana. All rights reserved.
            </p>
            <p className="text-sm text-[#FDFBF7]/50">
              Leadership & Workplace Well-being Advisor
            </p>
          </div>
          <p className="text-center text-xs text-[#FDFBF7]/30 mt-6">
            Made with Victory Interactive Inc
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
